import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

const pluralize = require('pluralize');


export default class TimeDelayNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Delay (seconds)';
        this.id = 'node_time_delay';
        this.icon = 'GiBackwardTime';
        this.linkedFeature = 'general';
        this.isAsync = true;

        const settings: Setting[] = [
            {
                id: 'DURATION',
                name: 'Duration (seconds)',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                helpText: 'The duration of the delay in seconds. The minimum value is 0.1 seconds.',
                max: 65535,
                min: 0.1,
                default: '1',
            },
        ];

        this.settings = this.settings.concat(settings);

        this.inputs = [
            {
                name: 'Delay',
                portId: 'delay_start',
                params: [],
            },
        ];

        this.outputs = [
            {
                name: 'Elapsed',
                portId: 'delay_elapsed',
                params: [],
            },
        ];
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const project: ProjectConfiguration = this.project;
            const DURATION = this.getSettingValue('DURATION');
            return `Delay for ${DURATION} ${pluralize('second', Number(DURATION))}`;
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const DURATION = this.getSettingValue('DURATION');
        return `Delay for ${DURATION} ${pluralize('second', Number(DURATION))}`;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `
This block triggers after the specified delay. This block is asynchronous and will not block the flow of the program.`;
    }
}
